export default function stringForNumber(number) {
  return number === 0 ? '0' : number || '';
  // return isNaN(number) ? '' : String(number)
  // return isInteger(number)
  //     ? `${number}.0`
  //     : (number || '')
}
